/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const OutsideWork = ({
    outsideWork,
}: Partial<{
    outsideWork: {
        planOnUndertaking?: boolean;
        details?: string;
    };
}>) => (
    <>
        <Row>
            <ValueCell
                single
                label="Plan on undertaking outside work"
                value={outsideWork?.planOnUndertaking ? 'Yes' : 'No'}
            />
        </Row>
        <Row>
            <ValueCell label="Outside Work Details" value={outsideWork?.details} />
        </Row>
    </>
);

export default OutsideWork;
